<template>
  <div>
    <Modal
      v-model="showModal"
      width="860"
      :transfer="true"
      class="modal-box"
      :footer-hide="true"
      @on-ok="handleOk"
      @on-cancel="handleCancel"
    >
      <p slot="header">
        批量设置<span
          v-if="calssList.length"
          style="padding-left: 10px; color: #999999"
        >(已选班级{{ calssList.length }})</span>
      </p>
      <div class="iconTips">
        <Icon
          type="md-alert"
          size="16"
          color="#ff9900"
          style="padding-right: 10px"
        ></Icon>每次只能批量修改一项
      </div>
      <div class="modal-content">
        <div class="modal-left">
          <div class="menu-box">
            <Menu
              mode="vertical"
              :active-name="menuName"
              @on-select="handleMenu"
            >
              <MenuItem
                v-for="(item, index) in menuList"
                :key="index"
                :name="item.menuName"
              >
                {{ item.name }}
              </MenuItem>
            </Menu>
          </div>
        </div>
        <div class="modal-right">
          <div v-if="menuName == 1" class="item1">
            <Form label-position="right" :label-width="80">
              <FormItem label="发送通知:">
                <Radio :value="true">是</Radio></FormItem>
              <FormItem label="推送方式:">
                <Radio :value="true">微信公众号（需家长先关注）</Radio>
              </FormItem>
              <p class="color-gray">将通知学生家长，该课程正式开班成功！</p>
              <p class="color-red">
                提示：仅通知未发送过的班级，已发送过的班级不会再次发送！
              </p>
              <p
                class="color-blue cursor-pointer"
                style="text-decoration: underline"
                @click="handleViewPic"
              >
                查看发送后的效果示例
              </p>
            </Form>
          </div>
          <div v-if="menuName == 2" class="item2">
            <h2>短信内容：</h2>
            <div>
              <span>【{{ projectName }}】尊敬的老师，您任教的</span>{{ classNameStr }},
              <Input
                v-model="batchData.smsContent"
                type="textarea"
                :rows="3"
                placeholder="请输入推送内容"
              ></Input>
            </div>
            <Form label-position="right" :label-width="80">
              <FormItem label="推送方式:" class="form-aline">
                <CheckboxGroup v-model="batchData.single">
                  <Checkbox label="1255">微信公众号（需教师先关注）</Checkbox>
                  <Checkbox v-if="portOrg!=2" label="1254">短信</Checkbox>
                </CheckboxGroup>
              </FormItem>
            </Form>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="showPic"
      title="如何加入课程班级群"
      width="900"
      :footer-hide="true"
    >
      <div class="pic-main">
        <img src="../assets/img/schema_bg@2x.png">
      </div>
    </Modal>

    <Modal
      v-model="resultModal"
      title="发送结果"
      :closable="false"
      :mask-closable="false"
      width="700"
    >
      <div class="modal-main">
        <div class="flex align-items" style="margin-bottom: 10px">
          <Icon
            v-if="loading"
            type="ios-loading"
            size="18"
            class="spin-icon-load"
            color="blue"
          ></Icon>
          <p style="font-size: 18px; margin-left: 8px">
            成功：<span
              class="color-green"
              style="margin-right: 20px; font-size: 18px"
            >{{ successNum }}条{{
            }}</span>
            失败：<span
              class="color-red"
              style="font-size: 18px"
            >{{ failNum }}条</span>
          </p>
        </div>
        <div v-if="failNum > 0" class="list-main">
          <h2>失败的课程班级信息：</h2>
          <ul>
            <li
              v-for="(item, index) in failData"
              :key="index"
              class="color-red"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handleResultOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { formatTimeHour, formatTime } from '@/utils/utils';
import courseCenterApi from '@/request/courseCenter/index.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import timer from '@/utils/timer.js';
export default {
  props: {
    calssList: {
      type: Array,
      default: () => []
    },
    goodsType: {
      type: String,
      default: 'goods' // goods：商品的批量设置  Combo：套餐的批量设置
    },
    activeselection: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPic: false,
      showModal: false,
      resultModal: false,
      menuName: '1',
      batchData: {
        smsContent: '正式开班成功，请及时登录小程序上传班级群二维码，方便家长入群沟通。如已上传请忽略。',
        // single: ['1255', '1254']
        single: ['1255']
      },
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      portOrg: localStorage.getItem('portOrg'),
      successNum: 0,
      failNum: 0,
      failData: [],
      batchIds: '',
      loading: false
    };
  },
  computed: {
    ...mapGetters(['theUserIdentity']),
    ...mapState(['projectName']),
    classNameStr() {
      return this.calssList.map(item => { return item.classroomName; }).join(',');
    },
    menuList() {
      return [
        {
          menuName: '1',
          name: '给家长发送开班成功通知'
        }, {
          menuName: '2',
          name: '通知任课教师开班成功'
        }
      ];
    }
  },
  watch: {
    activeselection: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.length === 1) {
          this.batchData.topDeadline = newVal[0].topDeadline ? newVal[0].topDeadline : '';
        } else {
          this.batchData.topDeadline = '';
        }
      }
    },
    showModal: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.menuName = this.menuList[0].menuName;
          });
        }
      }
    }
  },
  created() {
    this.menuName = this.menuList[0].menuName;
  },
  methods: {
    handleShow() {
      this.showModal = true;
      this.batchData = {
        smsContent: '正式开班成功，请及时登录小程序上传班级群二维码，方便家长入群沟通。如已上传请忽略。',
        // single: ['1255', '1254']
        single: this.portOrg == 2 ? ['1255'] : ['1255', '1254']
      };
      this.menuName = this.menuList[0].menuName;
      this.loading = false;
      timer.clearTimer('batchClassSettingCheckTask');
    },
    handleResultOk() {
      this.resultModal = false;
    },
    handleViewPic() {
      this.showPic = true;
    },
    // 切换菜单
    handleMenu(name) {
      this.menuName = name;
    },
    // 批量设置点击取消
    handleCancel() {
      this.showModal = false;
    },
    async getTaskStatusInfo() {
      const params = {
        busiCode: 14, //
        pageSize: 100,
        pageNo: 1,
        batchIds: this.batchIds ? [this.batchIds] : [],
        procStsList: [0, 1, 2, 3],
        exeFlag: 1
      };
      this.loading = true;
      const res = await courseSchedulCenter.getTaskStatusListApi(params);

      if (res.status == 200 && res.message.list.length) {
        const resultInfo = res.message.list[0].batchProcData;
        const lineData3 = resultInfo.lineData3 ? JSON.parse(resultInfo.lineData3) : null;
        if (lineData3) {
          this.successNum = lineData3.successNum;
          this.failNum = lineData3.failNum;
          this.failData = lineData3.errorMsg;
        }
        if (resultInfo.procSts == 1) {
          timer.clearTimer('batchClassSettingCheckTask');
          this.loading = false;
        }
      } else {
        timer.clearTimer('batchClassSettingCheckTask');
      }
    },
    async openClassNotice(parameter) {
      this.$Spin.show();
      const res = await courseSchedulCenter.openClassNotice(parameter);
      this.$Spin.hide();
      if (res.status == 200) {
        this.batchIds = res.message;
        this.showModal = false;
        this.resultModal = true;
        this.successNum = 0;
        this.failNum = 0;
        this.failData = [];
        this.getTaskStatusInfo();
        timer.addTimer('batchClassSettingCheckTask', this.getTaskStatusInfo, 3000);
      }
    },
    // 批量设置点击确定
    handleOk() {
      let params;
      const classroomIdList = this.calssList.map(item => { return item.classroomId; });
      let parameter;
      switch (this.menuName) {
        case '1':
          parameter = {
            noticeChannel: 1,
            classroomIdList,
            msgTypeList: ['1253']

          };
          this.openClassNotice(parameter);
          break;
        case '2':
          if (!this.batchData.smsContent) {
            this.$Message.warning('请输入推送内容');
            return null;
          }
          if (this.batchData.single.length == 0) {
            this.$Message.warning('请选择要推送的方式');
            return null;
          }
          parameter = {
            noticeChannel: 2,
            classroomIdList,
            msgTypeList: this.batchData.single,
            toTeaContent: this.batchData.smsContent
          };
          this.openClassNotice(parameter);
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.pic-main {
  width: 100%;
  padding: 36px 130px;
  img {
    width: 100%;
  }
}
.modal-box {
  .iconTips {
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin: 0 0 10px 10px;
    width: 600px;
    height: 30px;
    background-color: #fadfb8;
    border: solid 1px #ff9900;
  }
  .modal-content {
    display: flex;
    justify-content: space-around;
    .modal-left {
      float: left;
    }
    .modal-right {
      float: right;
      width: 500px;
      span {
        color: rgb(160, 161, 161);
        font-size: 10px;
      }
      .item1 {
        div {
          margin: 11px 0;
        }
      }
      .item3 {
        .labelName {
          margin: 3px 0;
        }
        .batchItem {
          margin: 10px 0;
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
        }
      }
      .item2 {
        div {
          margin: 4px 0;
        }
      }
      .item4 {
        margin: 10px 0;
        .list-item {
          display: flex;
          align-items: flex-start;
        }
      }
    }
  }
}
/deep/.form-aline.ivu-form-item {
  display: flex;
  align-items: center;
  .ivu-form-item-content {
    margin-left: 0 !important;
  }
}
</style>
